import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { to: "/", label: "Accueil" },
  { to: "/proprietes", label: "Propriétés" },
  { to: "/estimer", label: "Estimer mes revenus" },
  { to: "/formations", label: "Formations" },
  { to: "/evenements", label: "Événements" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isHome = pathname === "/";

  const goToLocations = (e) => {
    e.preventDefault();
    setOpen(false);
    const scroll = () => {
      const el = document.getElementById("locations");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    };
    if (pathname === "/") {
      scroll();
    } else {
      navigate("/");
      setTimeout(scroll, 400);
    }
  };

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  const solid = scrolled || !isHome;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        solid
          ? "bg-[#0b1f33]/95 backdrop-blur-md py-3 shadow-lg"
          : "bg-transparent py-6"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <Link to="/" className="flex flex-col leading-none">
          <img
            src="/brand/bella-logo-white.png"
            alt="Bella Edifices"
            className="h-10 md:h-12 w-auto object-contain"
          />
          <span className="text-[10px] md:text-[11px] tracking-[0.35em] text-white/70 uppercase mt-1 ml-1">
            Immobilier | Mexique
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7 xl:gap-9 whitespace-nowrap">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to.replace("/", "") || "home"}`}
              className={`nav-link text-sm tracking-wide text-white/90 hover:text-white ${
                pathname === l.to ? "active text-white" : ""
              }`}
            >
              {l.label}
            </Link>
          ))}
          <a
            href="/#locations"
            onClick={goToLocations}
            className="nav-link text-sm tracking-wide text-white/90 hover:text-white cursor-pointer"
          >
            Locations &amp; Gestion
          </a>
          <Link
            to="/contact"
            className="btn-gold text-sm font-600 px-5 py-2.5 rounded-sm tracking-wide"
          >
            Prendre rendez-vous
          </Link>
        </nav>

        <button
          className="lg:hidden text-white"
          onClick={() => setOpen((o) => !o)}
          aria-label="menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0b1f33] border-t border-white/10 px-6 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`text-base tracking-wide ${
                pathname === l.to ? "text-[#2f74c9]" : "text-white/90"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <a
            href="/#locations"
            onClick={goToLocations}
            className="text-base tracking-wide text-white/90 cursor-pointer"
          >
            Locations &amp; Gestion
          </a>
          <Link
            to="/contact"
            className="btn-gold text-sm font-600 px-5 py-3 rounded-sm text-center"
          >
            Prendre rendez-vous
          </Link>
        </div>
      )}
    </header>
  );
}
